var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestoreIcon = function SvgRestoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.941,
    height: 17.924,
    viewBox: "0 0 13.941 17.924"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e81c5c",
    "data-name": "Group 1488"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.569 2.842A161 161 0 0 1 9.483.517 1.54 1.54 0 0 0 8.333 0H1a1 1 0 0 0-1 1v15.932a1 1 0 0 0 1 1h11.949a1 1 0 0 0 1-1V5.464l-.076-.084Zm-9.573-.851H8.08l3.873 4.245v9.7H1.996Z",
    "data-name": "Path 914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.782 5.977a3.55 3.55 0 0 0-2.682 1.4 3.4 3.4 0 0 0-.24.369l-.15-.395a.511.511 0 1 0-.9.483l.9 1.93a.51.51 0 0 0 .692.209l2-.963a.5.5 0 0 0 .248-.3.511.511 0 0 0-.731-.6l-.581.242a2 2 0 0 1 .2-.24 1.956 1.956 0 1 1 1.709 3.32 1.94 1.94 0 0 1-1.848-.71 1.2 1.2 0 0 0-1.139-.032c-.371.192-.438.514-.146.907a3.517 3.517 0 1 0 2.668-5.62",
    "data-name": "Path 915"
  }))));
};
export default SvgRestoreIcon;